export enum ADD_OR_UPDATE_VALUES {
  ADD = 'Add',
  UPDATE = 'Update',
  NO_CHANGE = 'No Change',
  FIELD = 'addOrUpdate',
}

export const ADD_OR_UPDATE_SORT_ORDER = [
  ADD_OR_UPDATE_VALUES.ADD,
  ADD_OR_UPDATE_VALUES.UPDATE,
  ADD_OR_UPDATE_VALUES.NO_CHANGE,
];

export enum TabTypes {
  VIEW = 'VIEW',
  IMPORT = 'IMPORT',
}
